import type { ReactNode } from "react";

type PageShellProps = {
  children: ReactNode;
  maxWidth?: "lg" | "5xl" | "6xl" | "full";
};

const widthClasses: Record<NonNullable<PageShellProps["maxWidth"]>, string> = {
  lg: "max-w-lg",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  full: "max-w-none",
};

export function PageShell({ children, maxWidth = "6xl" }: PageShellProps) {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <div
        className={`mx-auto flex min-h-screen w-full ${widthClasses[maxWidth]} flex-col`}
        style={{ padding: "var(--page-padding-y) var(--page-padding-x)" }}
      >
        {children}
      </div>
    </main>
  );
}
